import { render, staticRenderFns } from "./OneTabs.vue?vue&type=template&id=28a5f4d1&scoped=true&lang=pug&"
import script from "./OneTabs.vue?vue&type=script&lang=ts&"
export * from "./OneTabs.vue?vue&type=script&lang=ts&"
import style0 from "./OneTabs.vue?vue&type=style&index=0&id=28a5f4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5f4d1",
  null
  
)

export default component.exports